module.exports = __webpack_public_path__ + "static/media/twitter.5a7822da.svg";